export default __webpack_public_path__ + "static/media/onlinePrivacyNotice.3a53184e.pdf";